export function formatLocale(locale) {
	if (typeof locale !== 'string') locale = '';
	locale = locale.trim();

	// Normalize dash-based locales like "fr-fr" to "fr_FR"
	if (locale.includes('-')) {
		const parts = locale.split('-');
		return `${parts[0].toLowerCase()}_${parts[1].toUpperCase()}`;
	}

	// Handle simple locales case like 'fr'
	const map = {
		en: 'en_US',
		fr: 'fr_FR',
		de: 'de_DE',
		es: 'es_ES',
		nl: 'nl_NL',
	};

	// Return mapped value or default to "xx_XX" pattern
	return map[locale] ?? (locale.length === 2 ? `${locale}_${locale.toUpperCase()}` : locale);}
